<template>
  <chart
    class="bar-chart"
    :type="'bar'"
    :data="graph_data_bar"
    :options="optionsPointSummaryBar"
  />
</template>
<!--
  JAVASCRIPT
-->
<script lang="babel">
  import { mapGetters } from 'vuex';
  import optionsPointSummaryBar from 'mixins/pointSummaryBarChartOptions';

  // colors for bar chart
  const lightRed = 'rgba(255, 99, 132, 0.2)';
  const red = 'rgba(255, 99, 132, 1)';
  // const lightBlue = 'rgba(54, 162, 235, 0.2)';
  // const blue = 'rgba(54, 162, 235, 1)';
  // simple bar options
  const redBars = {
    backgroundColor: Array(4).fill(lightRed),
    borderColor: Array(4).fill(red),
    borderWidth: 2,
  };
  // const blueBars = {
  //   backgroundColor: Array(4).fill(lightBlue),
  //   borderColor: Array(4).fill(blue),
  //   borderWidth: 2,
  // };

  export default {
    data() {
      return {};
    },
    components: {
      Chart: require('components/chartJS/chartJS'),
    },
    mixins: [optionsPointSummaryBar],
    computed: {
      ...mapGetters([
        'getStudentSummaryLD',
      ]),
      graph_data_bar() {
        const teacherDataSet = {
          ...redBars,
          label: 'Teacher',
          data: this.prepPointsForBarChart('teacher').data,
        };
        // const studentDataSet = {
        //   ...blueBars,
        //   label: 'Students',
        //   data: this.prepPointsForBarChart('student').data,
        // };
        // const datasets = [teacherDataSet, studentDataSet];
        const datasets = [teacherDataSet];
        const data = {
          labels: this.prepPointsForBarChart('total').labels,
          datasets,
        };
        return data;
      },
    },
    methods: {
      setMaxAxes(currentX, currentY, timesSpoken, rewardCount) {
        let maxX = Math.max(timesSpoken || 0, currentX);
        let maxY = Math.max(rewardCount || 0, currentY);

        maxX = timesSpoken === maxX && (maxX % 5 === 0) ?
          maxX + 5 : Math.ceil(maxX / 5) * 5;

        maxY = rewardCount === maxY &&
          (maxY % 10 === 0) ? maxY + 10 :
            Math.ceil(maxY / 10) * 10;

        return { maxX, maxY };
      },
      prepPointsForBarChart(type) {
        const payload = { labels: [], data: [] };
        const pointsSettings = this.getStudentSummaryLD.points_settings;
        const peerRewards = pointsSettings.peer_rewards;
        const rewardsReceived = this.getStudentSummaryLD.rewards_received;

        if (!pointsSettings) { return payload; }
        if (type === 'total' && rewardsReceived) {
          payload.labels = peerRewards.map(reward => reward.title);
          payload.data = peerRewards.map((reward) => {
            if (rewardsReceived[reward.tag]) {
              return rewardsReceived[reward.tag].total_count;
            }
            return 0;
          });
          return payload;
        }
        if (rewardsReceived) {
          // Create an array with labels
          payload.labels = peerRewards.map(reward => reward.title);
          // Create array with the data
          payload.data = peerRewards.map((reward) => {
            if (!rewardsReceived[reward.tag]) { return 0; }
            let total = 0;
            const breakdown = rewardsReceived[reward.tag].breakdown;
            // Count the rewards and tally them by student or teacher
            if (type === 'teacher') {
              breakdown.forEach((r) => {
                if (r.is_teacher) { total += r.points; }
              });
            }
            if (type === 'student') {
              breakdown.forEach((r) => {
                if (!r.is_teacher) { total += r.points; }
              });
            }
            return total;
          });
        }
        return payload; // default: return payload with empty labels and data arrays
      },
    },
  };
</script>
<!--
  CSS
-->
<style lang="scss"></style>



// WEBPACK FOOTER //
// individualStudentLDGraph.vue?3fe60ac4